/**
 * svc-promo returns `{ errors: [{ code, message }] }` for channel markup failures (e.g. 400/404/409).
 * Prefer the first specific error message, falling back to the generic error text.
 */
export default function getChannelMarkupErrorMessage(error: unknown): string {
  if (typeof error === 'object' && error !== null && 'errors' in error && Array.isArray(error.errors)) {
    const message = error.errors.find(
      (item): item is { message: string } =>
        typeof item === 'object' && item !== null && 'message' in item && typeof item.message === 'string',
    )?.message;

    if (message) {
      return message;
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  return String(error);
}
